import { createSelector } from "reselect"

const createTopFieldSelectorFactory = topState => field =>
  createSelector(topState, state => state && state[field])

export default createTopFieldSelectorFactory
